import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.url.to-json.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { defineIntegration } from '../integration.js';
import { DEBUG_BUILD } from '../debug-build.js';
import { isError, isPlainObject } from '../utils-hoist/is.js';
import { logger } from '../utils-hoist/logger.js';
import { normalize } from '../utils-hoist/normalize.js';
import { addNonEnumerableProperty } from '../utils-hoist/object.js';
import { truncate } from '../utils-hoist/string.js';
var INTEGRATION_NAME = 'ExtraErrorData';

/**
 * Extract additional data for from original exceptions.
 */
var _extraErrorDataIntegration = function _extraErrorDataIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$depth = options.depth,
    depth = _options$depth === void 0 ? 3 : _options$depth,
    _options$captureError = options.captureErrorCause,
    captureErrorCause = _options$captureError === void 0 ? true : _options$captureError;
  return {
    name: INTEGRATION_NAME,
    processEvent: function processEvent(event, hint, client) {
      var _client$getOptions = client.getOptions(),
        _client$getOptions$ma = _client$getOptions.maxValueLength,
        maxValueLength = _client$getOptions$ma === void 0 ? 250 : _client$getOptions$ma;
      return _enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
    }
  };
};
var extraErrorDataIntegration = defineIntegration(_extraErrorDataIntegration);
function _enhanceEventWithErrorData(event) {
  var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var depth = arguments.length > 2 ? arguments[2] : undefined;
  var captureErrorCause = arguments.length > 3 ? arguments[3] : undefined;
  var maxValueLength = arguments.length > 4 ? arguments[4] : undefined;
  if (!hint.originalException || !isError(hint.originalException)) {
    return event;
  }
  var exceptionName = hint.originalException.name || hint.originalException.constructor.name;
  var errorData = _extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
  if (errorData) {
    var contexts = _objectSpread({}, event.contexts);
    var normalizedErrorData = normalize(errorData, depth);
    if (isPlainObject(normalizedErrorData)) {
      // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
      // potentially truncate the data we just already normalized, with a certain depth setting.
      addNonEnumerableProperty(normalizedErrorData, '__sentry_skip_normalization__', true);
      contexts[exceptionName] = normalizedErrorData;
    }
    return _objectSpread(_objectSpread({}, event), {}, {
      contexts: contexts
    });
  }
  return event;
}

/**
 * Extract extra information from the Error object
 */
function _extractErrorData(error, captureErrorCause, maxValueLength) {
  // We are trying to enhance already existing event, so no harm done if it won't succeed
  try {
    var nativeKeys = ['name', 'message', 'stack', 'line', 'column', 'fileName', 'lineNumber', 'columnNumber', 'toJSON'];
    var extraErrorInfo = {};

    // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
    for (var _i = 0, _Object$keys = Object.keys(error); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (nativeKeys.indexOf(key) !== -1) {
        continue;
      }
      var value = error[key];
      extraErrorInfo[key] = isError(value) || typeof value === 'string' ? truncate("".concat(value), maxValueLength) : value;
    }

    // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
    if (captureErrorCause && error.cause !== undefined) {
      extraErrorInfo.cause = isError(error.cause) ? error.cause.toString() : error.cause;
    }

    // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
    if (typeof error.toJSON === 'function') {
      var serializedError = error.toJSON();
      for (var _i2 = 0, _Object$keys2 = Object.keys(serializedError); _i2 < _Object$keys2.length; _i2++) {
        var _key = _Object$keys2[_i2];
        var _value = serializedError[_key];
        extraErrorInfo[_key] = isError(_value) ? _value.toString() : _value;
      }
    }
    return extraErrorInfo;
  } catch (oO) {
    DEBUG_BUILD && logger.error('Unable to extract extra data from the Error object:', oO);
  }
  return null;
}
export { extraErrorDataIntegration };